// src/layouts/AdminMasterLayout.jsx

import { useState } from "react";
import { Container } from "react-bootstrap";
import AdminSidebar from "../components/admin/adminsidebar/AdminSideBar";
import Topbar from "../components/admin/admintopbar/TopBar";
import "../assets/css/admin/adminmasterlayout/AdminMasterLayout.css";

const AdminMasterLayout = ({ children }) => {
  // Desktop: sidebar collapsed or expanded
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Mobile: sidebar open or closed (overlay mode)
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleMenuToggle = () => {
    if (window.innerWidth <= 768) {
      // Mobile: toggle overlay sidebar
      setIsMobileOpen((prev) => !prev);
    } else {
      // Desktop: collapse/expand sidebar
      setIsCollapsed((prev) => !prev);
    }
  };

  const closeMobileSidebar = () => setIsMobileOpen(false);

  return (
    <div
      className={`admin-master-layout ${isCollapsed ? "sidebar-collapsed" : ""}`}
    >
      {/*
        AdminSidebar ka apna overlay (ad-sidebar-overlay) already hai
        toh yahan alag overlay ki zaroorat nahi.
        Mobile pe sidebar position:fixed hai — flex flow se bahar.
        AdminMasterLayout.css mein .ad-sidebar-container { width: 0 }
        se mobile pe extra space nahi lega.
      */}
      <AdminSidebar
        isCollapsed={isCollapsed}
        isMobileOpen={isMobileOpen}
        onClose={closeMobileSidebar}
      />

      <div className="admin-layout-main-content">
        {/* Topbar — scroll se bahar, hamesha upar */}
        <Topbar onMenuToggle={handleMenuToggle} />

        {/* Sirf yeh area scroll karega */}
        <div className="admin-layout-scroll-area">
          <Container fluid>
            <div className="admin-master-layout-grid">{children}</div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default AdminMasterLayout;
